import * as React from 'react';
import { IResort, ICurrency } from '../types';
import { resortSectionTitle } from '../helpers';
import YadoItemResort from './YadoItemResort';
import YadoResortSectionTitleView from './views/YadoResortSectionTitleView';

interface IProps {
  resorts: IResort[];
  exclude: IResort[];
  currency: ICurrency;
}

const YadoResortSection: React.FC<IProps> = (props) => {
  const { resorts, exclude, currency } = props;
  if (resorts.length === 0) { return null; }
  const title = resortSectionTitle(resorts);
  return (
    <React.Fragment>
      {title && <YadoResortSectionTitleView>{title}</YadoResortSectionTitleView>}
      {resorts.map(resort => (
        !exclude.some(r => r.code === resort.code) &&
          <YadoItemResort
            currency={currency}
            key={resort.code}
            code={resort.code}
            name={resort.name}
            access_minutes={resort.access_minutes}
            lift_min_price={resort.lift_min_price}
            rental_min_price={resort.rental_min_price} />
      ))}
    </React.Fragment>
  )
}

export default YadoResortSection;
